import { Alert, Snackbar } from '@mui/material';
import { create } from 'zustand';

type Severity = 'success' | 'error' | 'warning' | 'info';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: Severity;
  show: (message: string, severity?: Severity) => void;
  hide: () => void;
}

export const useSnackbar = create<SnackbarState>((set) => ({
  open: false,
  message: '',
  severity: 'info',
  show: (message, severity = 'info') => set({ open: true, message, severity }),
  hide: () => set({ open: false }),
}));

export const GlobalSnackbar = () => {
  const { open, message, severity, hide } = useSnackbar();

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={hide}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={hide} severity={severity} variant="filled" elevation={6}>
        {message}
      </Alert>
    </Snackbar>
  );
};
